import { React, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';



const NotFoundPage = () => {

    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            window.location.reload();
            navigate('/')
        }, 3000);
        
    } ,[])

    return (
        <div>
            <h1>404 - Page Not Found</h1>
            <p>The page you are looking for does not exist.</p>
        </div>
    );
}

export default NotFoundPage;